// extracted by mini-css-extract-plugin
module.exports = {"mecha":"index-mecha-ze5Sq","btnDetail":"index-btnDetail-1ojvW"};